import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import '../styles/bootstrap.min.css';
import '../styles/style.css';
import favicon from '../assets/images/fav_icon.png';
import about_bg from '../assets/images/about-background.svg';
import vision_img from '../assets/images/vision_img_box.png';
import image_safty from '../assets/images/image_safty.png';
import verified from '../assets/images/verified.svg';
import press_icon from '../assets/images/press_icon.png';
import Footer from '../components/Footer';
import FeaturedPostAbout from '../components/FeaturedPostAbout';
import config from '../config/config';

const About = () => {
  const [aboutContent, setAboutContent] = useState(null);
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('token');
    const headers = {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    };

    axios.get(`${config.baseURL}/get-about-page-content`, { headers })
      .then(response => {
        const { data } = response;
        if (data && data.success) {
          setAboutContent(data.data['page-content']);
          document.title = data.data['page-seo'].meta_title;
          document
            .querySelector('meta[name="description"]')
            .setAttribute('content', data.data['page-seo'].meta_description);
          document
            .querySelector('meta[name="keywords"]')
            .setAttribute('content', data.data['page-seo'].meta_keyword);
        }
      })
      .catch(error => {
        console.error('Error fetching about page content:', error);
      });
  }, []);

  const handleBackClick = () => {
    navigate(-1); // Go back to the previous page
  };

  const toggleMenu = () => {
    setMenuOpen(!menuOpen); // Toggle the menu visibility
  };

  

  return (
    <div>
      <div className="static_header_inner about_header">
        <div className="container">
          <div className="col-md-12">
            <div className="static_header_logo ticket_header ticker_header_with_search">
              <Link to="/" className="about_page_link">
                <img src={favicon} alt="Favicon" />
                PatreonPass
              </Link>
              <button className="menu_toggle" onClick={toggleMenu}>
                ☰
              </button>
              <div
                className={`about_page_menu ${menuOpen ? 'open' : ''}`}
                // Add 'open' class when menuOpen is true
              >
                <ul>
                  <li>
                    <a href="#about">About</a>
                  </li>
                  <li>
                    <a href="#mission">Mission</a>
                  </li>
                  <li>
                    <a href="#approach">Safety</a>
                  </li>
                  <li>
                    <a href="#posts">Creators</a>
                  </li>
                  <li>
                    <a href="#contact">Contact</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      {aboutContent ? (
        <>
          <section className="about_containers" id="about">
            <div className="container">
              <div className="row">
                <div className="col-md-12">
                  <div className="content_about">
                    <h3>Who We Are</h3>
                    <div className="heighlight_content">
                      {aboutContent.firstcontent}
                    </div>
                    <div className="img_bg">
                      <img src={about_bg} alt="About Background" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section className="mission_containers" id="mission">
            <div className="container">
              <div className="row">
                <div className="col-md-12">
                  <div className="content_about">
                    <div className="mission_values_text">
                      MISSION, VISION AND VALUES
                    </div>
                    <div className="mission_img">
                      <img src={vision_img} alt="Vision" />
                    </div>
                    <div className="heighlight_content">
                      {aboutContent.secondcontent}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section className="approcah_containers" id="approach">
            <div className="container">
              <div className="row">
                <div className="col-md-12">
                  <div className="content_about">
                    <div className="img_safty">
                      <img src={image_safty} alt="Safety" />
                    </div>
                    <div className="mission_values_text">
                      OUR APPROACH TO SAFETY
                    </div>
                    <div className="heighlight_content">
                      {aboutContent.thirdcontent}
                    </div>
                    <div className="about_btn_wrap">
                      <Link className="about_btn" to="/transparency-center">
                        Transparency center
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section className="posts_containers" id="posts">
            <div className="container">
              <div className="row">
                <div className="col-md-12">
                  <div className="content_about">
                    <div className="mission_values_text">
                      OUR CREATORS
                    </div>
                    <div className="heighlight_content">
                      {aboutContent.fourthcontent}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section className="posts_containers_list post_content_aboutpage">
            <div className="container_post">      
                <FeaturedPostAbout />
            </div>
          </section>

          <section className="mission_containers conact_block" id="contact">
            <div className="container">
              <div className="row">
                <div className="col-md-12">
                  <div className="content_about">
                    <div className="press_img">
                      <img src={press_icon} alt="Press" />
                    </div>
                    <div className="mission_values_text">
                      Press
                    </div>
                    <div className="heighlight_content">
                      <div className="heighlight_content" dangerouslySetInnerHTML={{ __html: aboutContent.fivthcontent }}></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section className="approcah_containers get_help"> 
            <div className="container">
              <div className="row">
                <div className="col-md-12">
                  <div className="content_about">
                    <div className="heighlight_content">
                        <span>Patreon Pass support can be reached at </span>
                        <Link href="mailto:support@patreonpass.com">support@patreonpass.com</Link>
                    </div>
                    <div className="about_btn_wrap">
                      <Link className="about_btn" to="/help">
                        Get Help
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <Footer />
        </>
      ) : (
        <div>Loading...</div>
      )}
    </div>
  );
};

export default About;
